import classes from "./ThirdStep.module.scss"
import body from "../../../index.module.scss";
import PinkBg from '../../PinkBlock/PinkBlock';
import SectionTitle from "../../Titles/SectionTitle/SectionTitle";
import Carousel from '../../Carousel/Carousel';


import graph1       from "../../Assets/Img/Src/Slider/2.png"
import graph2       from "../../Assets/Img/Src/Slider/2_2.png"
import graph3       from "../../Assets/Img/Src/Slider/up.png"
import graph4       from "../../Assets/Img/Src/Slider/search2.png"
import graph1Webp   from "../../Assets/Img/Webp/Slider/2.webp"
import graph2Webp   from "../../Assets/Img/Webp/Slider/2_2.webp"
import graph3Webp   from "../../Assets/Img/Webp/up.webp"
import graph4Webp   from "../../Assets/Img/Webp/search2.webp"


const mediaFile = [
  {
    img: graph1 ,
    imgWebp: graph1Webp,
    title: "Рост общего трафика",
  },
  {
    img: graph2 ,
    imgWebp: graph2Webp,
    title: "Рост SEO\n трафика",
  },
  {
    img: graph3 ,
    imgWebp: graph3Webp,
    title: "Рост конверсии сайта с 1,8% до 4% ",
  },
  {
    img: graph4 ,
    imgWebp: graph4Webp,
    title: "Рост количества страниц в индексе более чем в 20 раз",
  },
]
const ThirdStep = ()=> {
  return( 
    <section id="Result" className={classes.ThirdStep}>
      <PinkBg
          customClass={classes.PinkBg}
          number={3}
          CustomNumClass={classes.Number}
          />
        <div className={body.container}>
          <div className={classes.Wrap}>
            <SectionTitle text={<>ПОЛУЧЕННЫЕ<br/> РЕЗУЛЬТАТЫ</>} customClass={classes.Title}/>
            <h3 className={classes.About}>За период с&nbsp;февраля 2018 по&nbsp;ноябрь 2020</h3>
            
              <Carousel
              media={mediaFile}
              id="2"
              customClass="ThirdStep-carousel"
              />
        </div>
        </div>
    </section>
  )
}


export default ThirdStep;